<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-9">
            <span ngbAutofocus translate="Modals.ForcePermission.Title"></span>
        </h3>
    </div>

    <div class="p-4 pt-0">
        <div class="mb-3 col-12 min-height-modal-forcepermissions">
            <span translate="Modals.ForcePermission.Message{{level}}" [translateParams]="{permission: ('Permissions.Names.' + forPermission | translate) }"></span>
        </div>
        <div class="col-12 mt-4 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()" translate>Button.Back</button></span>
            <span class="float-end"><button type="submit" (click)="force()" class="btn btn-sm btn-secondary" translate>Button.Force</button></span>
        </div>
    </div>
</div>